import VsToast from '@vuesimple/vs-toast';
import route from '@/router';
import store from '@/store/index'
import { v4 } from 'uuid';
import { computed } from 'vue';

export default class FuncoesHelper {
    static notificar(tipo, titulo, mensagem, duration = 5000) {
        VsToast.show({
            title: titulo,
            message: mensagem,
            variant: tipo,
            duration: duration
        });
    }

    static obterParametrosRota(parametro) {
        const parametroRota = route.currentRoute.value.params[parametro];
        if (!parametroRota) return null;
        if (parametro === 'etapa') {
            return parseInt(parametroRota.toString());
        }
        return parametroRota;
    }

    static gerarUuid() {
        return v4();
    }

    static pushRouter(nomeRota, parametros) {
        route.push({ name: nomeRota, params: parametros });
    }

    static dataPt(dataString) {
        if (!dataString) {
            return dataString;
        }

        const partes = dataString.split('/');
        if (partes.length === 3) {
            const [dia, mes, ano] = partes;
            if (dia.length === 2 && mes.length === 2 && ano.length === 4) {
                return dataString;
            }
        }

        const partesFormatoPadrao = dataString.split('-');
        if (partesFormatoPadrao.length === 3) {
            const [ano, mes, dia] = partesFormatoPadrao;
            if (dia.length === 2 && mes.length === 2 && ano.length === 4) {
                return `${dia}/${mes}/${ano}`;
            }
        }
    }

    static formatarTelefone(telefone) {
        if (!telefone) {
            return '-';
        }
        const numeroLimpo = telefone.replace(/\D/g, '');
        if (numeroLimpo.length === 11) {
            return `(${numeroLimpo.slice(0, 2)}) ${numeroLimpo.slice(2, 7)}-${numeroLimpo.slice(7)}`;
        } else {
            return telefone;
        }
    }

    static validarChecklistPreview() {
        const preview = computed(() => store.state.preview)
        return preview.value
    }

    /**
     * @async
     * @param {string} imageData
     * @param {string} marcaDAgua
     * @param {Object} [options={}]
     * @param {string} [options.font='20px Arial']
     * @param {string} [options.fillStyle='rgba(255, 255, 255, 0.7)']
     * @param {string} [options.textAlign='right']
     * @param {string} [options.textBaseline='bottom']
     * @param {number} [options.width]
     * @param {number} [options.height]
     * @returns {Promise<string>}
     */
    static async mesclarImagemComMarcaDAgua(imageData, marcaDAgua, options = {}) {
        return new Promise((resolve) => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            const img = new Image();
            img.src = imageData;

            img.onload = () => {
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenhar a imagem editada no canvas
                ctx.drawImage(img, 0, 0);

                // Adicionar a marca d'água
                ctx.font = options.font ?? '20px Arial';
                ctx.fillStyle = options.fillStyle ?? 'rgba(255, 255, 255, 0.7)';
                ctx.textAlign = options.textAlign ?? 'right';
                ctx.textBaseline = options.textBaseline ?? 'bottom';
                ctx.fillText(marcaDAgua, options.width ?? (canvas.width - 10), options.height ?? (canvas.height - 10));

                // Converter o canvas para DataURL
                resolve(canvas.toDataURL('image/png'));
            }
        })
    }

    static extrairMimetypeETamanhoImageData(imageData) {
        const base64DataUrlRegex = /^data:image\/[a-zA-Z]+;base64,[0-9a-zA-Z+/]+={0,2}$/;

        if (!base64DataUrlRegex.test(imageData)) {
            throw new Error("O formato da imagem não é válido. Certifique-se de que ela esteja codificada em base64.");
        }

        const mimeType = imageData.match(/^data:(.*?);/)[1];
        const base64String = imageData.split(',')[1];
        const base64Length = base64String.length;
        const padding = (base64String.endsWith("==") ? 2 : base64String.endsWith("=") ? 1 : 0);
        const byteSize = (base64Length * 3) / 4 - padding;

        return {
            mimeType,
            byteSize
        }
    }

    static async verificarPermissaoCamera() {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            stream.getTracks().forEach(track => track.stop()); // interrompe o stream imediatamente
            return true;
        } catch (err) {
            if (err.name === 'NotAllowedError' || err.name === 'SecurityError') {
                return false; // permissão negada
            } else if (err.name === 'NotFoundError') {
                return null; // nenhuma câmera disponível
            } else {
                console.error('Erro inesperado ao acessar a câmera:', err);
                return null;
            }
        }
    }
}
